import React from 'react';
import { string } from 'prop-types';

import GoogleIcon from './google.svg';
import styles from './GoogleButton.module.scss';

const GoogleButton = ({ text, createdOnCampaign }) => {
  const campaign = createdOnCampaign ? `/${createdOnCampaign}` : '';

  return (
    <a
      href={`${process.env.REACT_APP_URL_BASE_API}/users/login/google${campaign}`}
      className={styles.button}
    >
      <img src={GoogleIcon} alt="Google signup" />
      <span className={styles.text}>{text}</span>
      <div />
    </a>
  );
};

GoogleButton.propTypes = {
  text: string.isRequired,
  createdOnCampaign: string,
};

export { GoogleButton };
